document.addEventListener('DOMContentLoaded', function() {
  if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();
          this.form = this.querySelector('form');
          this.variantIdInput.disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton.querySelector('span');

          if (document.querySelector('cart-drawer')) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }

          this.hideErrors = this.dataset.hideErrors === 'true';
        }

        onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

          this.handleErrorMessage();

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);

          // Check if the product has the "running" tag and modify quantity
          const tag = formData.get('properties[tag]');
          if (tag === 'running') {
            let quantity = parseFloat(formData.get('quantity'));
            formData.set('quantity', (quantity * 2).toString()); // Double the quantity
          }

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              updateCartQuantity(response.variant_id);
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
               
                return;
              } 
              else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              }
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } 
              else {
                this.cart.renderContents(response);
              }
              
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) {
                this.cart.classList.remove('is-empty');
              }
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
        }

        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;

          this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
          
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }

        toggleSubmitButton(disable = true, text) {
          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (text) this.submitButtonText.textContent = text;
          } else {
            this.submitButton.removeAttribute('disabled');
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }

        get variantIdInput() {
          return this.form.querySelector('[name=id]');
        }
      }
    );
  }

// function updateCartQuantity(variantId) {
//   fetch('/cart.js')
//     .then(response => response.json())
//     .then(cart => {
//       let item = cart.items.find(item => item.variant_id === variantId);
//       let cartQty = item ? item.quantity : 0;

//       // Update quantity display for cart
//       document.querySelectorAll('.quantity__rules-cart').forEach(function(element) {
//         if (cartQty > 0) {
//           element.classList.remove('hidden');
//           element.querySelector('span').innerHTML = `(${cartQty})`;
//         } else {
//           element.classList.add('hidden');
//         }
//       });

//       // Retrieve the available quantity
//       let availableQty = 0;
//       document.querySelectorAll('.avilable-qty').forEach(function(element) {
//         availableQty = parseInt(element.querySelector('span').textContent.trim());
//       });

//       // Calculate the remaining quantity
//       let remainingQty = availableQty - cartQty;

//       // Update the remaining quantity display
//       document.querySelectorAll('.remaining-qty').forEach(function(element) {
//         if (remainingQty > 0) {
//           element.classList.remove('hidden');
//           element.querySelector('span').innerHTML = remainingQty;
//         } else {
//           element.classList.add('hidden');
//         }
//       });
//     })
//     .catch(error => {
//       console.error('Error updating cart quantity:', error);
//     });
// }
   function updateRemainingQuantity() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let cartQty = 0;
        let variantId = document.querySelector('input[name="id"]').value;

        let item = cart.items.find(item => item.variant_id == variantId);
        cartQty = item ? item.quantity : 0;

        // Retrieve the available quantity
       let availableQty = 0;
       document.querySelectorAll('.product__inventory').forEach(function(element) {
          const textContent = element.textContent.trim();
          const match = textContent.match(/(\d+(\.\d+)?)/); // Match one or more digits
          
          if (match) {
             availableQty = parseFloat(match[0]);
         
            // Check if the element has the data-loose-fabric attribute
            if (element.hasAttribute('data-loose-fabric')) {
               
              availableQty = (availableQty).toFixed(1) ;
              cartQty = (cartQty / 2).toFixed(1) ;
            }
          }
        });
        console.log(availableQty + " availableQty"); // This will log the adjusted value, e.g., "3.0 meters"
        console.log(cartQty + " cartQty");

        // Calculate the remaining quantity
        var remainingQty = parseFloat(availableQty) - parseFloat(cartQty) ;
        console.log((remainingQty).toFixed(1)  + " remainingQty");

        // Update the remaining quantity display
        document.querySelectorAll('.remaining-qty').forEach(function(element) {
          if (remainingQty > 0 && remainingQty < availableQty ) {
            element.classList.remove('hidden');
            element.querySelector('span').innerHTML = remainingQty.toFixed(1) ;
          } else {
            element.classList.add('hidden');
          }
        });
        document.querySelectorAll('.quantity__input').forEach(function(element) {
          if (element.hasAttribute('data-loose-fabric-tag')) {
            element.setAttribute('data-loose-fabric-tag', availableQty) ;
          }
        });
        document.querySelectorAll('.quantity__rules-cart').forEach(function(element) {
          if (cartQty > 0) {
            element.classList.remove('hidden');
            if(element.hasAttribute('data-meters')){
              element.querySelector('span').innerHTML = `(${cartQty} meter in cart)`;
            }
            else{
              element.querySelector('span').innerHTML = `(${cartQty} in cart)`;
            }
          } else {
            element.classList.add('hidden');
          }
       
      });
      })
      .catch(error => {
        console.error('Error updating remaining quantity:', error);
      });
  }

  // Initial update when the page loads
  updateRemainingQuantity();

  // Update cart quantity and remaining quantity when adding to cart
  function updateCartQuantity(variantId) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let item = cart.items.find(item => item.variant_id === variantId);
        let cartQty = item ? item.quantity : 0;

        // Update quantity display for cart
        // document.querySelectorAll('.quantity__rules-cart').forEach(function(element) {
          
        //     if (cartQty > 0) {
        //       if(element.hasAttribute('data-select-tag')){
        //         var quantity = ( quantity /2 ).toFixed(1);
        //         console.log(quantity + "quantity quantity")
               
        //       }
        //       element.classList.remove('hidden');
        //       element.querySelector('span').innerHTML = `(${cartQty})`;
        //     } else {
        //       element.classList.add('hidden');
        //     }
         
        // });

        // Calculate the remaining quantity again after adding to the cart
        updateRemainingQuantity();
      })
      .catch(error => {
        console.error('Error updating cart quantity:', error);
      });
  }


});
